module.exports = __webpack_public_path__ + "img/Youtube.9fb0f6f8.png";